import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subtitle_track",
  "use": "icon-subtitle_track-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-subtitle_track\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M18.62,6.62V8.67H14v-2Zm0,4.35V13H12.46V11ZM12.31,6.62V8.67H9.87v5.38h-2V8.67H5.38v-2Zm6.31,8.71v2H5.38v-2ZM20,5H4V19H20Zm1-2a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol